module.exports = __webpack_public_path__ + "img/review-icon.3314d96e.svg";